import React from "react";
import { Trans } from "react-i18next";

import {
  Callout,
  Card,
  CardList,
  Classes,
  HTMLTable,
  Spinner,
  Tag,
} from "@blueprintjs/core";
import { ChevronRight } from "@blueprintjs/icons";

import { authenticatedGetFetch } from "../../../utils/AuthenticatedFetch";
import { mefDate, mefInterval } from "../../../utils/mef";

export default class ParkSaturations extends React.Component {
  constructor() {
    super();
    this.state = {
      loading: true,
      data: {},
      selected_park: "",
    };
  }

  componentDidMount() {
    this.setState({ loading: true }, () => {
      if (this.props.urlsearchparams !== undefined) {
        authenticatedGetFetch(
          "/activity/parks/saturations?" + this.props.urlsearchparams,
          (response) => {
            this.setState({
              data: response,
              loading: false,
              selected_park: Object.keys(response)[0] || "",
            });
          }
        );
      } else {
        this.setState({ loading: false });
      }
    });
  }

  render() {
    if (this.props.urlsearchparams === undefined) return null;
    const byPark = [];
    const saturationarray = {};
    for (const park in this.state.data) {
      let i = 0;
      byPark.push(
        <Card
          key={"sel" + park}
          interactive={true}
          onClick={() => this.setState({ selected_park: park })}
          selected={this.state.selected_park === park ? 5 : 0}
        >
          <div>
            {park}: <Tag intent="danger">{this.state.data[park]?.count}</Tag>{" "}
            saturations ({mefInterval(this.state.data[park]?.total)})
          </div>
          <ChevronRight className={Classes.TEXT_MUTED} />
        </Card>
      );

      saturationarray[park] = [];
      for (const period of this.state.data[park]?.periods) {
        saturationarray[park].push(
          <tr key={"slc" + i++}>
            <td>{mefDate(period.from)}</td>
            <td>{mefDate(period.to)}</td>
            <td>{mefInterval(period.seconds)}</td>
          </tr>
        );
      }
    }

    return (
      <div>
        <Callout icon="widget-button" title={<Trans>saturation periods</Trans>}>
          <div className="flexbox-center">
            {this.state.loading ? (
              <Spinner />
            ) : byPark.length > 0 ? (
              <>
                <div>
                  <CardList bordered={true} compact={true}>
                    {byPark}
                  </CardList>
                </div>
                <Card style={{ overflowY: "scroll", height: "30em" }}>
                  <HTMLTable striped={true} compact={true}>
                    <thead>
                      <tr>
                        <th>
                          <Trans>start date</Trans>
                        </th>
                        <th>
                          <Trans>end date</Trans>
                        </th>
                      </tr>
                    </thead>
                    <tbody>{saturationarray[this.state.selected_park]}</tbody>
                  </HTMLTable>
                </Card>
              </>
            ) : (
              <Callout intent="success">
                <Trans>no saturation on the selected period</Trans>
              </Callout>
            )}
          </div>
        </Callout>
      </div>
    );
  }
}
